module.exports = __webpack_public_path__ + "img/16.6bd93f8f.jpg";